import {Component, inject, OnDestroy, OnInit, TemplateRef} from '@angular/core';
import {Toast, ToastService} from '@xmedical/core';
import {Subscription} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'xui-toasts',
    templateUrl: './toasts.component.html',
    styleUrls: ['./toasts.component.scss'],
})
export class ToastsComponent implements OnInit, OnDestroy {
  private toastService = inject(ToastService);
  private snackbar = inject(MatSnackBar);
  private toastsSubscription: Subscription;

  isTemplate(toast) { return toast.textOrTpl instanceof TemplateRef; }

  ngOnInit(): void {
    this.toastsSubscription = this.toastService.toasts$.subscribe(toast => this.showToast(toast));
  }

  ngOnDestroy(): void {
    this.toastsSubscription?.unsubscribe();
  }

  private showToast(toast: Toast) {
    this.snackbar.open(toast.message, 'Dismiss', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: toast.options?.delay ?? 5000,
    });
  }
}
